const animItems = [
    // Главная
    {
        selector: '.page_main--layout-slide'
    }
];

export default animItems;